import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mb-40" }
const _hoisted_2 = { class: "col span-12" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col span-12" }
const _hoisted_5 = {
  class: "icon icon-info",
  tabindex: "0",
  role: "tooltip"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col span-12" }

import { computed, ref } from 'vue';
import Tab from '@shell/components/Tabbed/Tab.vue';
import Tabbed from '@shell/components/Tabbed/index.vue';
import ArrayList from '@shell/components/form/ArrayList.vue';
import { AuditPolicy } from '@shell/edit/auditlog.cattle.io.auditpolicy/types';

// Component Props & Emits

export default /*@__PURE__*/_defineComponent({
  __name: 'AdditionalRedactions',
  props: {
  value: {
    type:    Object,
    default: () => ({})
  },
  mode: {
    type:    String,
    default: 'create'
  },
},
  emits: ["update:value"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

// Default Values & Reactive Spec
const defaults: AuditPolicy = { additionalRedactions: [] };
const spec = ref<AuditPolicy>({ ...defaults, ...props.value });

// Methods
function addRedaction() {
  const valueToEmit = { ...props.value, ...spec.value };

  valueToEmit.additionalRedactions?.push({
    headers: [],
    paths:   [],
  });
  emit('update:value', valueToEmit);
}

function removeRedaction(tab: number) {
  const valueToEmit = { ...props.value, ...spec.value };

  valueToEmit.additionalRedactions?.splice(tab, 1);
  emit('update:value', valueToEmit);
}

const redactionLabel = computed(() => {
  return (i: number) => `Rule ${ i + 1 }`;
});

return (_ctx: any,_cache: any) => {
  const _directive_clean_tooltip = _resolveDirective("clean-tooltip")!
  const _directive_stripped_aria_label = _resolveDirective("stripped-aria-label")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Tabbed, {
          "side-tabs": true,
          "show-tabs-add-remove": __props.mode !== 'view',
          "use-hash": true,
          onAddTab: addRedaction,
          onRemoveTab: removeRedaction
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(spec.value.additionalRedactions, (redaction, idx) => {
              return (_openBlock(), _createBlock(Tab, {
                key: idx,
                name: `rule-${idx}`,
                label: redactionLabel.value(idx),
                "show-header": false,
                class: "container-group"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("fieldset", null, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.t("auditPolicy.additionalRedactions.headers.title")), 1),
                    _cache[0] || (_cache[0] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(ArrayList, {
                          key: "headers",
                          value: redaction.headers,
                          "onUpdate:value": ($event: any) => ((redaction.headers) = $event),
                          "value-placeholder": _ctx.t('auditPolicy.additionalRedactions.headers.placeholder'),
                          "add-label": _ctx.t('auditPolicy.additionalRedactions.headers.add'),
                          mode: __props.mode,
                          protip: false
                        }, null, 8, ["value", "onUpdate:value", "value-placeholder", "add-label", "mode"])
                      ])
                    ])
                  ]),
                  _cache[2] || (_cache[2] = _createTextVNode()),
                  _cache[3] || (_cache[3] = _createElementVNode("div", { class: "spacer" }, null, -1)),
                  _cache[4] || (_cache[4] = _createTextVNode()),
                  _createElementVNode("fieldset", null, [
                    _createElementVNode("h2", null, [
                      _createTextVNode(_toDisplayString(_ctx.t("auditPolicy.additionalRedactions.paths.title")) + " ", 1),
                      _withDirectives(_createElementVNode("i", _hoisted_5, null, 512), [
                        [_directive_clean_tooltip, {content: _ctx.t('auditPolicy.additionalRedactions.paths.tooltip'), triggers: ['hover', 'touch', 'focus'] }],
                        [_directive_stripped_aria_label, _ctx.t('auditPolicy.additionalRedactions.paths.tooltip')]
                      ])
                    ]),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(ArrayList, {
                          key: "paths",
                          value: redaction.paths,
                          "onUpdate:value": ($event: any) => ((redaction.paths) = $event),
                          "value-placeholder": _ctx.t('auditPolicy.additionalRedactions.paths.placeholder'),
                          "add-label": _ctx.t('auditPolicy.additionalRedactions.paths.add'),
                          mode: __props.mode,
                          protip: false
                        }, null, 8, ["value", "onUpdate:value", "value-placeholder", "add-label", "mode"])
                      ])
                    ])
                  ])
                ]),
                _: 2,
                __: [2,3,4]
              }, 1032, ["name", "label"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["show-tabs-add-remove"])
      ])
    ])
  ]))
}
}

})